import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

export default function SecuritySettings() {
  const { orgId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(`/enterprise/orgs/${orgId}/settings`)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        <div>
          <h1 className="font-heading text-2xl font-bold text-gray-900">Security Settings</h1>
          <p className="text-gray-600 mt-1">Manage authentication and security policies</p>
        </div>
      </div>

      <div className="space-y-4">
        <Card className="p-6 rounded-lg">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-enterprise-slate/10 rounded-lg">
              <ShieldCheck className="w-5 h-5 text-enterprise-slate" />
            </div>
            <h3 className="font-semibold text-gray-900">MFA Enforcement</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Require multi-factor authentication for all organization members
          </p>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <span className="text-sm text-gray-700">Status:</span>
            <span className="text-sm text-warning">Not Configured</span>
          </div>
        </Card>

        <Card className="p-6 rounded-lg">
          <h3 className="font-semibold text-gray-900 mb-4">IP Allowlist</h3>
          <p className="text-sm text-gray-600 mb-4">
            Restrict access to specific IP addresses or ranges
          </p>
          <Button variant="outline" size="sm">
            Configure IP Rules
          </Button>
        </Card>

        <Card className="p-6 rounded-lg">
          <h3 className="font-semibold text-gray-900 mb-4">Session Management</h3>
          <p className="text-sm text-gray-600 mb-4">
            Configure session timeout and security settings
          </p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between p-2">
              <span className="text-gray-600">Session Timeout:</span>
              <span className="font-medium">7 days</span>
            </div>
            <div className="flex justify-between p-2">
              <span className="text-gray-600">Idle Timeout:</span>
              <span className="font-medium">24 hours</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
